// extracted by mini-css-extract-plugin
export default {"root":"styles_root__RQMby","item":"styles_item__Sy3Tp"};